/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Header_Expand_Sidebar_AriaInputs */

const nl_app_header_expand_sidebar_aria = /** @type {(inputs: App_Header_Expand_Sidebar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijbalk uitklappen`)
};

/**

* @param {App_Header_Expand_Sidebar_AriaInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_header_expand_sidebar_aria = /** @type {((inputs?: App_Header_Expand_Sidebar_AriaInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Header_Expand_Sidebar_AriaInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_header_expand_sidebar_aria(inputs)
});
export { app_header_expand_sidebar_aria as "app.header.expand_sidebar_aria" }